<style>


  .container{
    padding: 16px;
    margin: 1em;
  }
  .profile-photo{
    display:flex;
    justify-content: center;
    align-items: center;

  }
  .profile-photo > img{
    max-height: 395px;
    clip-path: circle(40% at 46% 40%)  }
</style>
<div class="container">
  <div class="profile-photo">
    <img src="assets/Profile Photo.jpeg" alt="Profile Photo" >
  </div>
  <div>
    <p>Anthony Angatia is a passionate developer. Currently he is completing his Computer Science Degree at Strathmore University in Kenya.</p>
    <p>
       He is very thoughtful in his works and very practical.
        He always seeks the right way of doing things, basically, he likes clean code even though sometimes he breaks this rule when he run out of time.
         He prefers writing code rather than long stories.</p>
         <p>He is dedicated to his work and tries to get the job done.
            He aims to acquire and share vast knowledge in various technologies in the near future while putting his core focus on backend technologies.</p>
            <p>At times I make people laugh. I prefer a 'not dull' environment.</p>
            <p>Parting Shot: Never stop trying as long as you are convinced it is the right thing to do.
               However, `Nemo judex in causa sua` no-one is judge in his own cause. Get some good people to oversee 'it/you'.</p>
    <!-- <p>
      I am a skilled student in software engineering aspiring to venture into Internet applications development and Mobile application development.
    </p>
    <p>I am currently working on developing my blog site using Angular and Firebase and also skilling up in NodeJS and Android Development.</p>
      <p>
      I have tested my proficiency in JavaScript, Java and PHP languages in schoolwork and freelance projects. I have also engaged in machine learning tasks with python and Game development project using Godot game engine.
      I am interested in opportunities that can help me thrive in my skills especially backend development, software architecture and learn new skills.
    </p> -->

  </div>


</div>
